
const ALL_ITEMS = 'all';
const ACTIVE_ITEMS = 'active';
const COMPLETED_ITEMS = 'completed';
const ESCAPE_KEY = 27;
const ENTER_KEY = 13;

export {
  ALL_ITEMS,
  ACTIVE_ITEMS,
  COMPLETED_ITEMS,
  ENTER_KEY,
  ESCAPE_KEY
};


// WEBPACK FOOTER //
// ./modules/list/constants/ListStatus.js